import useOperationTranslation from "../../hooks/useOperationTranslation";

const EnumChangeName = () => {
  const t = useOperationTranslation();

  const locationType = (name: string) => {
    switch (name) {
      case "PARKING_GO":
        return t("internOptionSelectName.physicalLocationType.parkingGo");
      case "LMS":
        return t("internOptionSelectName.physicalLocationType.lms");
      case "COMPOUND":
        return t("internOptionSelectName.physicalLocationType.compound");
      case "SHOP_REPAIR":
        return t("internOptionSelectName.physicalLocationType.shopRepair");
      case "CONTRACTOR":
        return t("internOptionSelectName.physicalLocationType.contractor");
      case "CARRIER":
        return t("internOptionSelectName.physicalLocationType.carrier");
      case "INTERMEDIARY":
        return t("internOptionSelectName.physicalLocationType.intermediary");
      case "AFFILIATE":
        return t("internOptionSelectName.physicalLocationType.affiliate");
      default:
        return name;
    }
  };

  const transactionType = (name: string) => {
    switch (name) {
      case "RENT":
        return t("internOptionSelectName.transactionType.rent");
      case "TRANSPORT":
        return t("internOptionSelectName.transactionType.transport");
      default:
        return name;
    }
  };

  const statusType = (name: string) => {
    switch (name) {
      case "PROCESSED":
        return t("export.processed");
      case "PENDING":
        return t("export.pending");
      case "ERROR":
        return t("export.error");
    }
  };

  const rentStateType = (name: string) => {
    switch (name) {
      case "ONGOING_RENT":
        return t("internOptionSelectName.rentStateType.ongoingRent");
      case "CLOSED_RENT":
        return t("internOptionSelectName.rentStateType.closedRent");
      case "VOID_RENT":
        return t("internOptionSelectName.rentStateType.voidRent");
      case "FAILED_RENT":
        return t("internOptionSelectName.rentStateType.failedRent");
      default:
        return name;
    }
  };

  const transferType = (name: string) => {
    switch (name) {
      case "DRIVER":
        return t("transferReason.autocomplete.driver");
      case "CAR_TRANSPORTER":
        return t("transferReason.autocomplete.carTransporter");
      default:
        return "";
    }
  };

  const availabilityType = (name: string) => {
    switch (name) {
      case "AVAILABLE":
        return t("internOptionSelectName.available");
      case "NOT_AVAILABLE":
        return t("internOptionSelectName.notAvailable");
      default:
        return "";
    }
  };

  const yesNoType = (name: string) => {
    switch (name) {
      case "true":
        return t("internOptionSelectName.yes");
      case "false":
        return t("internOptionSelectName.no");
      default:
        return "";
    }
  };

  const booleanType = (name: string) => {
    switch (name) {
      case "true":
        return t("internOptionSelectName.active");
      case "false":
        return t("internOptionSelectName.notActive");
      default:
        return "";
    }
  };

  const activateType = (name: string) => {
    switch (name) {
      case "ACTIVE":
        return t("internOptionSelectName.active");
      case "NOT_ACTIVE":
        return t("internOptionSelectName.notActive");
      case "NEW":
        return t("internOptionSelectName.new");
      default:
        return "";
    }
  };

  const activatTerminatType = (name: string) => {
    switch (name) {
      case "Activated":
        return t("logisticCompound.option.activated");
      case "Terminated":
        return t("logisticCompound.option.terminated");
      default:
        return "";
    }
  };

  const state = (params: any) => {
    switch (params) {
      case "REJECTED":
        return t("transferReason.autocomplete.rejected");

      case "APPROVED":
        return t("transferReason.autocomplete.approved");
      case "TO_BE_APPROVED":
        return t("transferReason.autocomplete.toBeApproved");

      case "CREATED":
        return t("transferReason.autocomplete.created");

      case "APPROVED_WITH_DDT":
        return t("transferReason.autocomplete.approvedWithDdt");

      case "TRANSFER_COMPLETED":
        return t("transferReason.autocomplete.transferCompleted");

      case "DUPLICATE_CANCELLED_BY_SYSTEM":
        return t("transferReason.autocomplete.duplicateCancelledBySystem");
        
      default:
        break;
    }
  };

  return {
    locationType,
    transactionType,
    rentStateType,
    transferType,
    availabilityType,
    activateType,
    yesNoType,
    booleanType,
    activatTerminatType,
    state,
    statusType,
  };
};

export default EnumChangeName;
